import {Badge} from '@mantine/core';
import {Tooltip} from 'src/design/atoms/Tooltip';
import type {MantineSpacing} from '@mantine/core';
import {IconWifiOff} from '@tabler/icons-react';
import React from 'react';
import {useOfflineStatus} from 'src/offline/useOfflineStatus';

export interface OfflineStatusPillProps {
  /** Left margin passed to the badge root — e.g. `"auto"` to right-align. */
  ml?: MantineSpacing;
}

/** Compact inline offline indicator for slim chrome bars; null when online. */
export const OfflineStatusPill: React.FC<OfflineStatusPillProps> = ({ml}) => {
  const {isOffline, isSimulated, message} = useOfflineStatus();

  if (!isOffline) {
    return null;
  }

  return (
    <Tooltip label={message} withArrow>
      <Badge
        ml={ml}
        color="yellow"
        variant="filled"
        leftSection={<IconWifiOff size={14} />}
        aria-live="polite">
        {`Offline${isSimulated ? ' (simulated)' : ''}`}
      </Badge>
    </Tooltip>
  );
};
